const SoftwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": ["SoftwareApplication", "WebApplication"],
  "@id": "https://onbbits.io/#software",

  "name": "ONBBITS",

  "url": "https://onbbits.io/",

  "description":
    "ONBBITS is a WhatsApp Business API and automation platform that helps businesses automate conversations, manage customer engagement, run campaigns, and grow through WhatsApp.",

  "applicationCategory": "BusinessApplication",

  "applicationSubCategory": "WhatsApp Business Automation",

  "operatingSystem": "Web",

  "publisher": {
    "@id": "https://onbbits.io/#organization"
  }
};

export default SoftwareApplicationSchema;